module.exports = __webpack_public_path__ + "img/report-9.d227d697.jpeg";